anychat的麦克风，摄像头的设置页面
<template>
  <div class="anychatSetupContainer">
     <el-form ref="setForm">
      <el-form-item label="摄像头：">
        <el-select v-model="camera" size="small" >
          <el-option v-for="item in cameraList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="麦克风：" size="small">
        <el-select type="textarea"  rows="4" v-model="microphone" >
          <el-option v-for="item in microphoneList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="兼容模式：" size="small">
        <el-select type="textarea"  rows="4" v-model="isOpenMode" >
          <el-option v-for="item in openModeList" :key="item.key" :label="item.value" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="anychatSet-footer">
      <el-button class='testTTS' @click="testTTS" size="small">测试声音</el-button>
      <!-- <el-button type="primary" @click="testMicrophone" size="small" disabled>测试麦克风</el-button> -->
    </div>
  </div>
</template>
<script>
import Util from "@/oldCode/commonTools/util";

/* globals anychat,BRAC_Logout,renderGuid,BRAC_DEVICE_AUDIOCAPTURE,BRAC_SelectVideoCapture,AnyChatAIRobot,setRotation,GV_ERR_BROWSERNOWEBRTC,requestVideoCall,getRemoteAudioStream,getRemoteVideoStream,BRAC_SetUserStreamInfo,BRAC_STREAMINFO_AUDIOFLAG,
BRAC_SetVideoPos,sdkInit,enterRoom,videoAuthor,Base64,BRAC_UserSpeakControlEx,BRAC_STREAMINFO_VIDEOFLAG,openMedia,closeMedia,leaveRoom,BRAC_EnumDevices,BRAC_LeaveRoom,anychatLogout,BRAC_Release*/

export default {
  props: {
  
  },
  data () {
    return {
      videowspwebsocket : "",
      videowspUrl : "",
      serverIp : "",
      appId : "",
      serverPort : "",
      camera: "",
      microphoneList: [],
      isOpenMode: "",
      cameraList: [],
      openModeList: [{key:"1", value: "是"}, {key:"0", value: "否"}],
      microphone: "",
      robot: null,
      playtxt: "请问是否能听见当前播报话术？",
      taskid: "",
      showLoading: false,
      loadingText: "",
    };
  },
  watch:{
    showLoading (value){
      if(value){
        this.myLoading({
          loadingText: "正在初始化，请稍等...",
          autoHide: false
        });
      }else{
        this.myLoading({
          showLoading: false,
        });
      }
    }
  },
  mounted () {
    let that = this;
    return  Promise.all([
      that.$syscfg.getSysConfig("FXC_ANYCHAT_CONFIG"),
    ]).then(res=>{
      let anychatConfig = _.get(res,"[0].Data[0].PAR_VAL","");
      anychatConfig = anychatConfig.split("|");
      that.videowspwebsocket = anychatConfig[0];
      that.serverIp = anychatConfig[1];
      that.appId = anychatConfig[3];
      that.serverPort = anychatConfig[2];
      that.videowspUrl = anychatConfig[4];
      if(that.chromeVersion == 114 || parseInt(that.chromeVersion) >= 126){
        that.isOpenMode = that.openModeList[0];
      }
      that.initAnyachat();
    }).catch(err=>{
      consoleLog("请求公共参数失败", err);
    });
  },
  computed:{
    chromeVersion () {
      let browser = Util.getOSAndBrowser(), browserNum = "";
      if (browser.indexOf("Chrome") !== -1) {
        let info = browser.split("/")[1].replace("Chrome", "");
        browserNum = parseInt(info);
      } else {
        browserNum = "90";
      }
      return browserNum;
    }
  },
  beforeDestroy (){
    consoleLog("anychatSetup组件销户了");
    BRAC_LeaveRoom();
    anychatLogout();
    BRAC_Release();
  },
  methods: {
    releaseAnychatSource (){
      consoleLog("releaseAnychatSource组件销户了");
      BRAC_LeaveRoom();
      anychatLogout();
      BRAC_Release();
    },
    testTTS (){
      if(this.robot){
        this.playTTSStr(this.playtxt);
      }else{
        this.alert("anychat初始失败，请重试!");
      }
    },
    // testMicrophone (){
    //   this.startAsr();
    // },
    initAnyachat (){
      let that = this;
      that.showLoading = true;
      that.loadingText = "正在初始化，请稍等";
      let errorcode = sdkInit({
        serverIp:  that.serverIp, //这个值，要从后台配置来  
        serverPort:parseInt(that.serverPort), //这个值要从后台配置来  
        appId: that.appId, //这个值要从后台配置来.
        // serverIp: "h5dev.axzq.com.cn" ,
        // serverPort: 443, 
        // appId: "3A1F796F-850B-4041-973F-582E1E9545B3" ,
        onConnect: this.onConnect,
        onLogin: this.onLogin,
        nickName: "fdafdafdafda",
        onDisConnect: function (){
          that.showLoading = false;
          that.alert({
            messageText:"连接服务器失败，请重试",
            confirmButtonText: "重试",
            cancelButtonText:"确定",
            confirmedAction (){
              that.initAnyachat();
            }});
        },
      });
      if (errorcode != 0) {
        consoleLog("打开anychat失败");
        that.alert("打开anychat失败");
        that.showLoading = false;

      }
    },
    onConnect (){
      consoleLog("anychat打开成功");
    },
    onLogin (dwUserId, errorcode) {
      let that = this;
      if (errorcode === 0) {
        that.userId = dwUserId;
        consoleLog("h5anychat登录成功！用户id: " + dwUserId);
        enterRoom({
          roomId: that.roomId,
          done: that.onAnyChatEnterRoom,
        });
      } else {
        that.showLoading = false;
        that.alert("anychatErr,连接服务器失败" + errorcode);
      }
    },
    onAnyChatEnterRoom (dwRoomId, errorcode) {
      let that = this;
      if (errorcode == 0) {
        consoleLog("h5anychat进入房间 " + dwRoomId + " 成功");
        videoAuthor({
          done: that.OnAnyChatMediaAuthority,
        });
      } else {
        that.showLoading = false;
        that.alert("anychatErr,进入房间失败" + errorcode);
      }
    },
    //获取摄像头权限的回调
    OnAnyChatMediaAuthority (errorcode, res) {
      let that = this;
      let taskid = renderGuid();
      that.taskid = taskid;
      if (errorcode == 0) {
        consoleLog("h5anychat媒体授权成功");
        //根据签名视频或者双录视频，调用不同的摄像头
        that.getVideoList();
        that.getMicrophones();
        that.createRobot();
        //在这里获取摄像头，然后设定摄像头
        that.showLoading = false;
      } else {
        that.showLoading = false;
        that.alert("anychatErr,获取媒体权限失败,请授权" + errorcode);
      }
    },
    createRobot () {
      let that = this;
      this.robot = new AnyChatAIRobot({
        resultevent: (res) => {
          if (res.errorcode == 0) {
            consoleLog("机器人初始化成功！");
            that.talkIndex = 0;
            that.talkChildIndex = 0;
            //在创建完成机器人对象之后，先预处理所有的话术，启动录制，然后再进行话术的播报@wangmx 20211221
            that.prepareTTS(that.playtxt);
            //机器人初始化成功之后，调用摄像头
            // that.startRecord(true);
          }
        },
        errorevent: (err) => {
          consoleLog("打开机器人对象失败了");
          that.alert("初始化视频能力失败" + err.errorcode);
        },
      });
    },
    prepareTTS (content) {
      let that = this;
      that.robot.tts({
        content: content,
        state: 1,
        preprocess: 1, // 是否为预处理任务，0-否，1-是，如为1，则只检测是否存在缓存音频文件，并返回结果，不播放或返回音频数据
        event: (res) => { },
        resultevent: (res) => { 
          consoleLog("预处理tts成功");
        },
        errorevent: (res) => {
          consoleLog("TTS错误预处理：", res);
        },
        finishevent: (res) => {
          consoleLog("预处理话术成功");
        }
      });
    },
    playTTSStr (item, ctrlcode, flag) {
      let that = this;
      let content = item;
      consoleLog("调用了playttsstr," + "即将播放的内容" + content);
      this.robot.tts({
        content: content,
        state: 1,
        sectionmode: 1, //是否分段模式，0-否，1-是，如为1，则连续播放多段缓存语音
        ctrlcode: ctrlcode, // 0 开始播放；103 恢复播放；104：暂停播放；105：停止播放
        taskid: this.taskid,
        event: (res) => {
        },
        resultevent: (res) => {
          that.currentTTSTaskid = res.taskid; //tts任务id
          if (item.type == 1) {
            consoleLog("playTTSStr， resultevent type1");
          } else if (item.type == 2) {
            consoleLog("playTTSStr， resultevent type2");
          }
        },
        errorevent: (res) => {
          consoleLog("分段播放TTS错误：", res);
        },
        finishevent: (res) => {
          if (res) {
            consoleLog("h5anychat开始语音识别,并且打开话筒，录制声音");
          }
        }
      });
    },
    getVideoList () {
      let deviceArr = BRAC_EnumDevices(3);
      this.cameraList = deviceArr;
      consoleLog("获取到的摄像头的列表", deviceArr); 
      //默认加载第一个
      this.camera = deviceArr[0];
    },
    getMicrophones (){
      let deviceArr = BRAC_EnumDevices(2);
      this.microphoneList = deviceArr;
      consoleLog("获取到的麦克风的列表", deviceArr); 
      this.microphone = deviceArr[0];
    },
    closeCollect (){
      this.$emit("closeCollect");
    },
    changeDevice (value, type){
      if (type === 1) {
        //保存摄像头
      } else if (type === 2) {
        this.instance.selectAudioCapture({
          deviceName: value
        });
      }
    },
    stopAsr () {
      this.robot &&
        this.robot.stopASR({
          event: function (a) {
            // console.info(a)
          },
          resultevent: function (a) {
            // console.info(a)
          },
          errorevent: function (a) {
            // console.info(a)
          },
          finishevent: function (a) {
            // console.info(a)
          },
        });
    },
    startAsr () {
      let that = this;
      let asrContentAll = "";
      // BRAC_SelectVideoCapture(BRAC_DEVICE_AUDIOCAPTURE, this.microphone); //设置麦克风
      that.robot &&
        that.robot.startASR({
          event: function (res) {
            // if (item.type == 1) {
            //   //问答模式
            //   //回答问题开始时打标签
           
            // }
            // that.asrtimeOut = setTimeout(() => {
            //   that.stopAsr();
            // }, parseInt(that.anychatParam.custAnswerTime) * 1000);
          },
          resultevent: function (res) {
            asrContentAll = res.result;
            consoleLog("语音识别的结果",res.result);
            // asrContent = res.result;
            // asrContentAll += res.result;
            // //console.error("识别出来的语音内容：" + asrContent);
            // let flag = that.isEqualArrry(
            //   asrContent,
            //   item.broadcast.expectAnswer.split(",")
            // );

            // if (flag) {
            //   consoleLog(
            //     "resultevent 匹配成功了,并且通知下屏，去自动点击下一步"
            //   );
            //   clearTimeout(that.asrtimeOut);
            //   window.opener.document.getElementById("secondReceive").value =
            //     "h5NextVoice" + that.talkIndex;
            // }
          },
          errorevent: function (err) {
            consoleError("asr error", err);
            // if (item.type == 1) {
           
            // let flag = that.isEqualArrry(asrContent, item.broadcast.expectAnswer.split(','));
            // if (flag) {
            //   console.info("匹配成功了");
            //   that.step();
            // }
            // }
          },
          finishevent: function (res) {
            consoleLog("结束了语音识别, 语音识别的内容" + asrContentAll);
            // if (item.type == 1) {
         
            //   // let flag = that.isEqualArrry(asrContent, item.broadcast.expectAnswer.split(','));
            //   // console.info(flag, 111111);
            //   // if (flag) {
            //   //   console.info("语音识别匹配成功了");
            //   //   that.step();
            //   // }
            // } else if (item.type == 2) {
            //   // that.step();
            // }
          },
        });
    },
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.anychatSetupContainer{
  padding: 0 6% !important;
 /deep/ .el-form{
    .el-form-item{
      .el-form-item__label{
        font-size: .14rem!important;
         width: 1rem;
      }
      .el-form-item__content{
        .el-select{
          .el-input{
            input{
               width: 2.64rem;
               font-size: .12rem;
            }
          }
        }
      }
    }
  }
  .anychatSet-footer{
    text-align: center;
    .testTTS{
      .fontsize-btn-medium();
      transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear,-webkit-box-shadow .2s linear;
      background: #dcb369;
      color: #fff;
      padding: 0 0.2rem;
      border-radius: 0.04rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/anychatSetup.vue